import type { OverviewTriage } from '../../../services/dmMonitoringOverview';
import { BreakdownCard } from './BreakdownCard';
import { sumCounts } from './overviewFormat';
import { frustrationLegend, priorityLegend } from './overviewLegend';
import { OPEN_NOW_SUBTITLE } from './overviewPeriod';
import { DonutBreakdown, type PieSlice } from './OverviewDonut';
import { EmptyNote } from './StackedBar';

const UNSET_KEY = 'unset';
const EMPTY_NOTE = 'No open messages.';

interface TriagePieCardProps {
    title: string;
    info: string;
    slices: PieSlice[];
}

function TriagePieCard({ title, info, slices }: TriagePieCardProps) {
    const total = sumCounts(slices);
    return (
        <BreakdownCard title={title} info={info} subtitle={OPEN_NOW_SUBTITLE}>
            {total === 0 ? (
                <EmptyNote>{EMPTY_NOTE}</EmptyNote>
            ) : (
                <DonutBreakdown
                    slices={slices}
                    label={title}
                    center={{ value: total.toLocaleString(), caption: 'open' }}
                />
            )}
        </BreakdownCard>
    );
}

export function MessagesByPriorityCard({ priority }: { priority: OverviewTriage['priority'] }) {
    const slices = priority.map((entry) => ({
        key: entry.value,
        count: entry.count,
        ...priorityLegend(entry.value)
    }));
    return (
        <TriagePieCard
            title="Messages by priority"
            info="Patients with open messages, by the priority set in triage"
            slices={slices}
        />
    );
}

export function MessagesByFrustrationCard({
    frustration
}: {
    frustration: OverviewTriage['frustration'];
}) {
    const slices = frustration.map((entry) => ({
        key: entry.value ?? UNSET_KEY,
        count: entry.count,
        ...frustrationLegend(entry.value)
    }));
    return (
        <TriagePieCard
            title="Messages by frustration"
            info="Patients with open messages, by the frustration set in triage"
            slices={slices}
        />
    );
}
